import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer } from 'react-toastify';
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    const [customCompanyName, setCustomCompany] = useState('');
    const [isCustomCompany, setIsCustomCompany] = useState(false);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [address, setAddress] = useState('');
    const [earning, setEarning] = useState(0);
    useEffect(() => {
        cargarContacto();
    }, []);
    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            const daysCount = getSelectedDaysCount(item.weeklyOrder);
            totalPriceCalc += item.precio * item.cantidad * daysCount;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    useEffect(() => {
        cargarProductos();
        fetchCompanies();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    idProducto: cartItem.idProducto,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                    weeklyOrder: cartItem.weeklyOrder,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);
    useEffect(()=> {
        // Calcular el earning total: sum of item.profit * cantidad * daysCount
        let totalEarning = 0;
        cartItems.forEach(item => {
            console.log("cartitem", item);
            
            const daysCount = getSelectedDaysCount(item.weeklyOrder);
            const profitPerUnit = item?.profit || 0;
            totalEarning += profitPerUnit * item?.cantidad * daysCount;
            console.log("daysCount", daysCount);
            console.log("profitPerUnit", profitPerUnit);
            console.log("item?.cantidad", item?.cantidad);
        });
        console.log("totalEarning", totalEarning);
        
        setEarning(totalEarning);
    },[cartItems]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };
    const fetchCompanies  = () => {
        fetch(`${baseURL}/companiesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCompanies(data.companies || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    // Count selected days for a weeklyOrder (supports array or legacy object). Fallback to 1 if none selected.
    const getSelectedDaysCount = (weekly) => {
        if (!weekly) return 1;
        if (Array.isArray(weekly)) {
            const c = weekly.filter(d => d && d.deliver).length;
            return c > 0 ? c : 1;
        }
        const c = Object.keys(weekly || {}).filter(k => weekly[k]).length;
        return c > 0 ? c : 1;
    };

    // Update weeklyOrder for a cart item in localStorage and state
    const updateWeeklyForCartItem = (idProducto, newWeekly) => {
        // update localStorage cart (this storage was used to create cart items)
        try {
            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
            const idx = storedCart.findIndex(c => c.idProducto === idProducto);
            // Ensure at least one selected day: if none selected, auto-select the first day
            if (Array.isArray(newWeekly)) {
                const any = newWeekly.some(d => d && d.deliver);
                if (!any && newWeekly.length > 0) {
                    newWeekly = newWeekly.map((d, i) => i === 0 ? { ...d, deliver: true } : { ...d, deliver: false });
                }
            } else if (newWeekly && typeof newWeekly === 'object') {
                const any = Object.keys(newWeekly).some(k => newWeekly[k]);
                if (!any) {
                    const firstKey = Object.keys(newWeekly)[0];
                    if (firstKey) newWeekly[firstKey] = true;
                }
            }
            if (idx !== -1) {
                storedCart[idx].weeklyOrder = newWeekly;
                localStorage.setItem('cart', JSON.stringify(storedCart));
            }
        } catch (err) {
            console.error('Error updating cart in localStorage', err);
        }

        // update component state cartItems and recalculate total immediately
        setCartItems(prev => {
            const updated = prev.map(it => it.idProducto === idProducto ? { ...it, weeklyOrder: newWeekly } : it);
            // recalc total
            const newTotal = updated.reduce((acc, it) => {
                const days = getSelectedDaysCount(it.weeklyOrder);
                return acc + (it.precio * it.cantidad * days);
            }, 0);
            setTotalPrice(newTotal);
            return updated;
        });
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();

    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const handleWhatsappMessage = (orderId) => {
        const codigoDescuento = codigos.find(item => item.codigo === codigo);
        let descuentoActualizado = 0;

        if (codigoDescuento) {
            descuentoActualizado = codigoDescuento.descuento;
            setCodigoValido(true);
        } else {
            setCodigoValido(false);
        }

        let totalPrice = 0;

        cartItems.forEach(item => {
            const daysCount = getSelectedDaysCount(item.weeklyOrder);
            totalPrice += item.precio * item.cantidad * daysCount;
        });

        let totalPriceWithDiscount = totalPrice - descuentoActualizado;
        if (totalPriceWithDiscount < 0) {
            totalPriceWithDiscount = 0;
        }

        const formattedTotalPrice = totalPriceWithDiscount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phoneNumber = `${contactos.telefono}`;

        const cartDetails = cartItems.map((item) => (
            `\n➡️ *${item.titulo}* \n       Días: ${item.weeklyOrder.filter(d => d.deliver).map((day)=>day.name).join(", ")}\n       Precio: ${moneda} ${item.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} \n       ${item?.item}`
        ));

        let noteMessage = '';

        if (location.trim() !== '') {
            noteMessage += `\n✅ Ubicación: ${location}`;
        }

        if (name.trim() !== '') {
            noteMessage += `\n✅ Nombre: ${name}`;
        }

        if (noteText.trim() !== '') {
            noteMessage += `\n✅ Nota: ${noteText}`;
        }

        if (codigo.trim() !== '') {
            noteMessage += `\n✅ Codigo : ${codigo}\n✅ Descuento de : ${moneda} ${descuentoActualizado?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }

        // Añadir la dirección de entrega en el mensaje
        const entrega = deliveryOption === 'delivery' ? `Dirección de entrega: ${address}` : 'Retiro personalmente';

        const paymentMessage = paymentMethod === 'efectivo' ? 'Pago en efectivo' : 'Pago por transferencia bancaria';

        // const message = `¡Hola! 🌟 Estoy interesado en encargar:\n${cartDetails.join('')}\n------------------------------------>\n ${noteMessage}\n✅ ${entrega}\n✅ ${paymentMessage}\n\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*`;
        const message = `hello! Here's a summary of my order # ${orderId}\n ${cartDetails.join('')}\n 📩 ${name}\n 🚚 ${entrega} \n 👉🏾 ${paymentMessage}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
        setName('');
        setLocation('');
        setNoteText('');
        setCodigo('');
        setDescuento(descuentoActualizado);
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };


    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            // Construir la lista de productos del pedido
            // Helper: for order, include only selected days and set deliver:false so admin updates status later
            const normalizeWeeklyForOrder = (weekly) => {
                if (!weekly) return [];
                if (Array.isArray(weekly)) {
                    return weekly.filter(d => d.deliver).map(d => ({ name: d.name, date: d.date, deliver: false }));
                }
                // legacy object shape -> convert keys with true value into array entries with empty date
                return Object.keys(weekly).filter(k => weekly[k]).map(k => ({ name: k, date: '', deliver: false }));
            };

            const productosPedido = cartItems?.map(item => {
                return {
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    item: item?.item,
                    precio: item?.precio,
                    profit: item?.profit,
                    // only include selected days with deliver:false so admin can update later
                    weeklyOrder: normalizeWeeklyForOrder(item?.weeklyOrder),
                    idProducto: item?.idProducto,
                    imagen: obtenerImagen(item)
                };
            });
            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);
            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                const daysCount = getSelectedDaysCount(item.weeklyOrder);
                totalPrice += item?.precio * item?.cantidad * daysCount;
            });

            // Obtener el descuento del código de descuento
            const codigoDescuento = codigos?.find(item => item?.codigo === codigo);
            let descuentoCodigo = 0;

            if (codigoDescuento) {
                descuentoCodigo = codigoDescuento?.descuento;
            }

            // Aplicar el descuento del código de descuento
            const totalPriceWithDiscount = totalPrice - descuentoCodigo;

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();

            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            formData.append('nombre', name);
            formData.append('email', email);
            formData.append('telefono', telefono);
            console.log('Valor de direccion:', address);

            const entrega = deliveryOption === 'delivery' ? address : 'Retiro en personalmente';
            formData.append('entrega', entrega);

            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            formData.append('isCustomCompany', isCustomCompany ? '1' : '0');
            formData.append('selectedCompanyId', selectedCompanyId);
            formData.append('customCompanyName', customCompanyName);

            // append computed earning directly so we don't rely on async state update
            formData.append('earning', earning);
            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });
            console.log(entrega)
            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');

                Swal.fire({
                    title: 'Pedido enviado!',
                    text: data.mensaje,
                    icon: 'success',
                    confirmButtonText: 'Enviar por WhatsApp'
                }).then(() => {
                    // Solo después que el usuario hace clic en el botón
                    handleWhatsappMessage(data.idPedido);
                    setName('');
                    setCodigo('');
                    setNoteText('');
                    closeModal();
                    closeModal2();
                    clearCart();
                });
            }else if (data.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data.error,
                    'error'
                );
            }

        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );

        }
    };
    return (
        <div>
            <ToastContainer />
            <button onClick={openModal} className='cartIconFixed'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart' >
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {item?.item?.map((sabor, index) => (
                                                        <span key={index}> {sabor}</span>
                                                    ))}
                                                </span>
                                                <div className='weeklyEditWrapper'>
                                                    {
                                                        Array.isArray(item?.weeklyOrder) ? (
                                                            item.weeklyOrder.map((d, dayIdx) => (
                                                                <label key={d.name + d.date} className="checkBoxItem small">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={d.deliver}
                                                                        onChange={(e) => {
                                                                            const isChecked = e.target.checked;
                                                                            const newWeekly = item.weeklyOrder.map((wd, wi) => wi === dayIdx ? { ...wd, deliver: isChecked } : wd);
                                                                            updateWeeklyForCartItem(item.idProducto, newWeekly);
                                                                        }}
                                                                    />
                                                                    {d.name}
                                                                </label>
                                                            ))
                                                        ) : (
                                                            // legacy object shape
                                                            item?.weeklyOrder ? (
                                                                Object.keys(item.weeklyOrder).map((dayKey) => (
                                                                    <label key={dayKey} className="checkBoxItem small">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!!item.weeklyOrder[dayKey]}
                                                                            onChange={(e) => {
                                                                                const isChecked = e.target.checked;
                                                                                // create updated legacy object
                                                                                const newLegacy = { ...item.weeklyOrder, [dayKey]: isChecked };
                                                                                updateWeeklyForCartItem(item.idProducto, newLegacy);
                                                                            }}
                                                                        />
                                                                        {dayKey}
                                                                    </label>
                                                                ))
                                                            ) : (
                                                                <span>No hay días</span>
                                                            )
                                                        )
                                                    }
                                                </div>
                                                <strong>{moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                                <div className='productSubtotal'>
                                                    Subtotal: {moneda} {(item.precio * item.cantidad * getSelectedDaysCount(item.weeklyOrder)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                </div>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h4>

                            <div className='deFLexBtns'>

                                <button className='btnWpp' onClick={openModal2}>
                                    Pedir por WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                                </button>

                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre (obligatorio)'
                                />
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder='Email (obligatorio)'
                                />
                                <input
                                    type="number"
                                    id="telefono"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                    placeholder='Telefono (obligatorio)'
                                />
                                <div className='deFLexRadio'>
                                    <label>Opciones de entrega</label>

                                    <div
                                        onClick={() => setDeliveryOption('delivery')}
                                    >
                                        <input
                                            type="radio"
                                            id="delivery"
                                            name="deliveryOption"
                                            value="delivery"
                                            checked={deliveryOption === 'delivery'}
                                            onChange={() => setDeliveryOption('delivery')}
                                        />
                                        <label htmlFor="delivery">Envío a domicilio</label>
                                    </div>

                                    <div
                                        onClick={() => setDeliveryOption('pickup')}
                                    >
                                        <input
                                            type="radio"
                                            id="pickup"
                                            name="deliveryOption"
                                            value="pickup"
                                            checked={deliveryOption === 'pickup'}
                                            onChange={() => setDeliveryOption('pickup')}
                                        />
                                        <label htmlFor="pickup">Retirar personalmente</label>
                                    </div>


                                </div>
                                {deliveryOption === 'delivery' && (

                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Ingresa tu dirección (obligatorio)"
                                    />

                                )}
                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    <div >
                                        <input
                                            type="radio"
                                            id="efectivo"
                                            name="paymentMethod"
                                            value="efectivo"
                                            checked={paymentMethod === 'efectivo'}
                                            onChange={() => setPaymentMethod('efectivo')}
                                        />
                                        <label htmlFor="efectivo">Efectivo</label>
                                    </div>
                                    <div >
                                        <input
                                            type="radio"
                                            id="transferencia"
                                            name="paymentMethod"
                                            value="transferencia"
                                            checked={paymentMethod === 'transferencia'}
                                            onChange={() => setPaymentMethod('transferencia')}
                                        />
                                        <label htmlFor="transferencia">Transferencia</label>
                                    </div>

                                </div>
                                <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Codigo de descuento (opcional)'
                                />
                                <div className='companyWrapper'>
                                    {!isCustomCompany ? (
                                        <select id='companySelect' className='companySelect' value={selectedCompanyId} onChange={(e)=> {setSelectedCompanyId(e.target.value)}}>
                                            <option value="">Seleccione una compania</option>
                                            {companies.map((company) => (
                                                <option key={company.idCompany} value={company.idCompany}>
                                                {company.name}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            className="customCompanyName"
                                            id='customCompanyName'
                                            type="text"
                                            placeholder="Nombre de compañia"
                                            value={customCompanyName}
                                            onChange={(e) => setCustomCompany(e.target.value)}
                                        />
                                    )}
                                    <div>
                                        <label className='checkBoxItem'>
                                        <input
                                            type="checkbox"
                                            id='isCustomCompany'
                                            checked={isCustomCompany}
                                            onChange={(e) => setIsCustomCompany(e.target.checked)}
                                        />
                                        {' '}Compania no en la lista
                                        </label>
                                    </div>
                                </div>
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <fieldset className='deNonefieldset'>
                                    <legend>Productos</legend>
                                    <textarea
                                        name='productos'
                                        value={cartItems.map(item => `${item.titulo}, x ${item.cantidad}, ${item.item},${item.categoria},${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                        readOnly
                                    />
                                </fieldset>


                            </div>
                            {mensaje ? (
                                <button type='button' className='btn' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crearPedido} className='btn'>
                                    Finalizar pedido
                                </button>
                            )}
                        </Modal>

                    </>)}

            </Modal>
        </div >
    );
}
